import script from "./SolicitacoesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitacoesView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__